updateResult